// src/layouts/AdminNavContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import AdminNavDrawer from "./AdminNavDrawer";

const AdminNavContext = createContext({
  openNav: () => {},
  closeNav: () => {},
  toggleNav: () => {},
  isOpen: false,
});

export const AdminNavProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openNav = () => setIsOpen(true);
  const closeNav = () => setIsOpen(false);
  const toggleNav = () => setIsOpen((o) => !o);

  // Global keyboard: M to open/close
  useEffect(() => {
    const onKey = (e) => {
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA")
        return;
      if (e.key?.toLowerCase() === "m") toggleNav();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <AdminNavContext.Provider value={{ openNav, closeNav, toggleNav, isOpen }}>
      <AdminNavDrawer open={isOpen} onClose={closeNav} />
      {children}
    </AdminNavContext.Provider>
  );
};

export const useAdminNav = () => useContext(AdminNavContext);
